import React from "react";
import "./styles.css";

/**
 * @function UINotifiButton 
 * @param {STRING} text - Allows us to set the button text.
 * @param {FUNCTION} onClick - Allows us to set an event handler for the button when clicked.
 * @param {STRING} className - Allows us to pass a specific className to the button for primary and secondary buttons.
 * @param {STRING} data-point - Data point that should be applied to the button
 * @returns {React.Component}
 * @example
 * <UINotifiButton className="primary-button some-class" onClick={() => this.handleClick()} text="Some text" />
 */

export default function UINotifiButton(props) {
  const text = props.text ?? "[Button]";
  const className = props.className ?? "";
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

  return (
    <button className={`ui-notifi-button flex-width ${className}`} data-point={point} onClick ={props.onClick}>
      <span>{text}</span>
    </button>
  );
}